import { PathBase } from "@constellation-academy/epic-ui";

export class ExternalLicensePoolEditPath extends PathBase {
	static readonly pathKey = "edit";
}
